import Button from 'components/atoms/button';
import { formSections } from 'constants/ccmNarrative';
import PropTypes from 'prop-types';
import useNarrativeModal from 'utils/useNarrativeModal';
import { useSelector } from 'react-redux';
import DraggableModal from 'components/organisms/draggableModal/draggableModal';
import Section from './components/Section';

const CcmNarrativeModal = ({ onSubmit, closeModal, isOpen, patientGuid }) => {
  const {
    patient,
    questions: { groups },
    medications,
  } = useSelector((state) => state.ccmPatientDetails);

  const {
    values,
    currentStep,
    formHaveError,
    setValue,
    goToPrevStep,
    goToNextStep,
    submit,
  } = useNarrativeModal({
    onSubmit,
    closeModal,
    patient,
    medications,
    groups,
    patientGuid,
  });

  return (
    <DraggableModal
      isOpen={isOpen}
      toggle={closeModal}
      title={`${formSections[currentStep].title} - ${currentStep + 1} of ${
        formSections.length
      }`}
      styleName="popup narrative-popup"
    >
      <>
        <Section
          forms={formSections[currentStep].forms}
          setValue={setValue}
          values={values}
        />
        <div className="buttons-wrapper">
          {currentStep !== 0 && (
            <Button handleClick={goToPrevStep} text="< Back" fillBg={false} />
          )}
          {currentStep === formSections.length - 1 ? (
            <Button
              disabled={formHaveError}
              handleClick={submit}
              text="Submit"
            />
          ) : (
            <Button handleClick={goToNextStep} text="Forward >" />
          )}
        </div>
      </>
    </DraggableModal>
  );
};

CcmNarrativeModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  patientGuid: PropTypes.string,
};

export default CcmNarrativeModal;
